import React from "react";
import styles from "./Loader.module.css";

const Loader = () => {
  return <div className={styles.loader}>Loading...</div>;
};

export default Loader;
